/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var PropTypes = require("prop-types");
var react_popper_1 = require("react-popper");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Tooltip.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var GenericTransition_1 = require("./util/GenericTransition");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-tooltip");
var Tooltip = /** @class */ (function (_super) {
    tslib_1.__extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.childRef = null;
        _this.state = {
            visible: false
        };
        _this.innerRef = function (node) {
            _this.childRef = node;
        };
        _this.showTooltip = function () {
            _this.setState({ visible: true });
        };
        _this.hideTooltip = function () {
            _this.setState({ visible: false });
        };
        return _this;
    }
    Tooltip.prototype.componentDidMount = function () {
        if (this.childRef) {
            this.childRef.addEventListener("mouseenter", this.showTooltip);
            this.childRef.addEventListener("mouseleave", this.hideTooltip);
            this.childRef.addEventListener("focus", this.showTooltip);
            this.childRef.addEventListener("blur", this.hideTooltip);
        }
    };
    Tooltip.prototype.componentWillUnmount = function () {
        if (this.childRef) {
            this.childRef.removeEventListener("mouseenter", this.showTooltip);
            this.childRef.removeEventListener("mouseleave", this.hideTooltip);
            this.childRef.removeEventListener("focus", this.showTooltip);
            this.childRef.removeEventListener("blur", this.hideTooltip);
        }
    };
    Tooltip.prototype.render = function () {
        var _a = this.props, children = _a.children, id = _a.id, title = _a.title, className = _a.className, _b = _a.forwardRefAs, forwardRefAs = _b === void 0 ? "ref" : _b, props = tslib_1.__rest(_a, ["children", "id", "title", "className", "forwardRefAs"]);
        var visible = this.state.visible;
        var onlyChild = React.Children.only(children);
        return (React.createElement(react_popper_1.Manager, null,
            React.createElement(react_popper_1.Reference, { innerRef: this.innerRef }, function (_a) {
                var ref = _a.ref;
                var _b;
                return onlyChild &&
                    React.cloneElement(onlyChild, (_b = {},
                        _b[forwardRefAs] = ref,
                        _b["aria-labelledby"] = id,
                        _b));
            }),
            React.createElement(GenericTransition_1.Fade, { in: visible },
                React.createElement(react_popper_1.Popper, tslib_1.__assign({ placement: "top", modifiers: {
                        preventOverflow: {
                            boundariesElement: "viewport"
                        }
                    } }, props), function (_a) {
                    var ref = _a.ref, style = _a.style, placement = _a.placement, arrowProps = _a.arrowProps;
                    return (React.createElement("span", { id: id, ref: ref, role: "tooltip", style: style, "data-placement": placement, className: classnames(moduleClassName(), className) },
                        title,
                        React.createElement("span", { ref: arrowProps.ref, style: arrowProps.style, className: moduleClassName("arrow") })));
                }))));
    };
    Tooltip.propTypes = {
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        forwardRefAs: PropTypes.string,
        className: PropTypes.string
    };
    return Tooltip;
}(React.Component));
exports.Tooltip = Tooltip;